import React from "react";

const NewsList = ({ news }) => {
  if (!news || news.length === 0) {
    return <p>Aucune actualité disponible.</p>;
  }

  return (
    <div className="space-y-4">
      {news.map((article, i) => (
        <a
          key={i}
          href={article.url}
          target="_blank"
          rel="noopener noreferrer"
          className="block p-4 border rounded-lg bg-white shadow hover:bg-gray-50 transition"
        >
          <h3 className="font-semibold text-blue-600">{article.title}</h3>
          <p className="text-sm text-gray-600">{article.description}</p>
        </a>
      ))}
    </div>
  );
};

export default NewsList;
